/* SHA screens (docs/plans/phase1-sha.md §9). Tokens only; states are words and shapes. */

.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.connection {
  font: var(--t-small);
  color: var(--graphite);
}

.schemes {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.scheme {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2) var(--space-3);
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}

.schemeLine {
  font: var(--t-body-strong);
}

.detail {
  font: var(--t-small);
  color: var(--graphite);
}

.id {
  font-family: var(--font-id);
  font-variant-numeric: tabular-nums;
}

.reasons {
  margin: 0;
  padding-left: var(--space-4);
  font: var(--t-body);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.table {
  width: 100%;
  border-collapse: collapse;
  font: var(--t-body);
}

.table th,
.table td {
  padding: var(--space-2) var(--space-3);
  border-bottom: 1px solid var(--rule);
  text-align: left;
  vertical-align: top;
}

/* Headers as in every Wodi table (DESIGN.md §7): t-micro, semibold, graphite. */
.table th {
  color: var(--graphite);
  font: var(--t-micro);
  font-weight: 600;
  vertical-align: bottom;
}

/* The claims list on a phone: claim, patient, amount and state. */
@media (width < 600px) {
  .claimsList th:nth-child(3),
  .claimsList td:nth-child(3),
  .claimsList th:nth-child(4),
  .claimsList td:nth-child(4),
  .claimsList th:nth-child(7),
  .claimsList td:nth-child(7) {
    display: none;
  }

  .claimsList table[aria-label] {
    min-width: 0;
  }
}

.number {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
